import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import Templates from "../../Sections/Templates";

const TemplatesComponent = () => {
    return (
        <Dashboard sectionName={<Templates />}/>
    );
};

export default TemplatesComponent;
